import { Container } from '@ivorobioff/shared';
import Budget from '../models/Budget';
import { Allocation, SendAllocationData } from '../models/Allocation';
import BudgetOperationService from './BudgetOperationService';
import { OperationIntent } from '../models/Operation';

export default class AllocationOperationService {
  private budgetOperationService: BudgetOperationService;

  constructor(container: Container) {
    this.budgetOperationService = container.get(BudgetOperationService);
  }

  async allocate(
    allocations: Allocation[],
    submissions: SendAllocationData[],
    { budgets }: { budgets: Budget[] }
  ): Promise<Budget[]> {

    const queues = new Map<string, ((budget: Budget) => Promise<Budget>)[]>();

    for (const allocation of allocations) {
      const queue = queues.get(allocation.accountId) || [];

      queue.push(async (budget) => {
        const amount = allocation.retained
          ? allocation.amount
          : submissions.find(({ allocationId }) => allocationId === allocation.id)?.amount;

        if (typeof amount !== 'number') {
          throw new Error(`Unable to resolve amount for allocation: ${allocation.source}`);
        }

        return this.budgetOperationService.submit(budget, {
          amount,
          intent: OperationIntent.Plus,
          note: `Allocated from ${allocation.source}`
        });
      });

      queues.set(allocation.accountId, queue);
    }

    return Promise.all([...queues.entries()].map(async ([accountId, jobs]) => {
      let budget = budgets.find((budget) => budget.accountId === accountId);

      if (!budget) {
        throw new Error(`Budget not found for account: ${accountId}`);
      }

      for (const job of jobs) {
        budget = await job(budget);
      }

      return budget;
    }));
  }
} 